module.exports = __webpack_public_path__ + "media/images/prismic_catalog/presentation_cards/universes/cleaning-9d05e261f6c19196e5dfa8aa75072d59.png";